import script from "./ArchiveViewEx.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveViewEx.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveViewEx.vue?vue&type=style&index=0&id=3c29713b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c29713b"]])

export default __exports__